import {GetSessionItem, SetSessionItem} from './Cache'
 
  export function cacheDropdownData(dropdownItem, fetchFunction, dataOverride = false) {
    const DDW_cache_status = JSON.parse(GetSessionItem(dropdownItem));
    let dropdownData = null;
  
    if (DDW_cache_status !== null && !dataOverride) {
      dropdownData = DDW_cache_status;
    } else {
      // to fetch data from the API using the provided fetchFunction...
      const fetch_API_dropdown_results = fetchFunction();
  
      SetSessionItem(dropdownItem, JSON.stringify(fetch_API_dropdown_results));
      dropdownData = fetch_API_dropdown_results;
    }
  
    return dropdownData;
  }
